import React, { useEffect, useState } from "react";
import { getData } from "utils/queries";
import { useParams } from "react-router-dom";
import Package from "../CreatePackage"
import { groupedData } from "utils";
 

const EditEvent = () => {

  const [package_, setPackage]= useState({})

  const {package_id} = useParams()

  const fetchEventDetails = async (event_id)=>{
    try {
      
      const result = await getData(`package/packages/${package_id}`)

      console.log("result ",result)

      // const groupedData = groupedData

      const packageDetails = result?.data?.data?.package;
      const packageElements = packageDetails?.elements?.map((ticket)=>{

        return({
          ...ticket,
          variants:ticket?.variants?.map((variant)=>({...variant,checked:true}))
        })
      })

       
      const modifiedData = {
        ...packageDetails,
        elements:packageElements
        
      }

      console.log("packageElements",modifiedData)

      setPackage(modifiedData)
    } catch (error) {
      
    }
  }


  useEffect(()=>{

    if(package_id){
      fetchEventDetails(package_id)
    }
  },[package_id])


 
   return <Package data={package_} package_id={package_id}/>
   
  
};

export default EditEvent;
